export enum SubscriptionDuration {
  ANNUALY = 'annualy',
  MONTHLY = 'monthly',
}

export const subscriptionDurationTitle: Record<SubscriptionDuration, string> = {
  [SubscriptionDuration.MONTHLY]: 'Monthly',
  [SubscriptionDuration.ANNUALY]: 'Annually',
};

export enum SubscriptionType {
  ENTERPRISE = 'enterprise',
  GROWTH = 'growth',
  START_UP = 'startup',
}

export const subscriptionTypeTitle: Record<SubscriptionType, string> = {
  [SubscriptionType.START_UP]: 'Start up',
  [SubscriptionType.GROWTH]: 'Growth',
  [SubscriptionType.ENTERPRISE]: 'Enterprise',
};

export enum SubscriptionStatus {
  ACTIVE = 'active',
  CANCELED = 'canceled',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  PAST_DUE = 'past_due',
  TRIALING = 'trialing',
  UNPAID = 'unpaid',
}

export const subscriptionStatusTitle: Record<SubscriptionStatus, string> = {
  [SubscriptionStatus.INCOMPLETE]: 'Incomplete',
  [SubscriptionStatus.INCOMPLETE_EXPIRED]: 'Incomplete expired',
  [SubscriptionStatus.TRIALING]: 'Trialing',
  [SubscriptionStatus.ACTIVE]: 'Active',
  [SubscriptionStatus.PAST_DUE]: 'Past due',
  [SubscriptionStatus.CANCELED]: 'Canceled',
  [SubscriptionStatus.UNPAID]: 'Unpaid',
};

export type Plan = {
  active: boolean;
  amount: number;
  created: number;
  currency: string;
  id: string;
};
